import { SxProps, Theme, Typography } from '@mui/material';
import { ReactNode } from 'react';

interface SsbSectionLabelProps {
  children: ReactNode;
  sx?: SxProps<Theme>;
}

function SsbSectionLabel({ children, sx }: SsbSectionLabelProps) {
  return (
    <Typography
      sx={[
        { fontSize: '11px', fontWeight: 600, letterSpacing: '0.08em', textTransform: 'uppercase', color: '#718096' },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {children}
    </Typography>
  );
}

export default SsbSectionLabel;
